import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import axios from 'axios';
var MAX_RETRIES = 5;
var second = 1000;
var baseDelay = 2 * second;
var backoff = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(currentRetry) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new Promise(function (resolve) {
            setTimeout(resolve, baseDelay * Math.pow(2, currentRetry));
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function backoff(_x) {
    return _ref.apply(this, arguments);
  };
}();
var putInS3 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(blob, signedUrlGenerator, abortController, onUploadProgress, retryPolicy) {
    var currentRetry,
      signedUrl,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          currentRetry = _args2.length > 5 && _args2[5] !== undefined ? _args2[5] : 0;
          _context2.prev = 1;
          _context2.next = 4;
          return signedUrlGenerator();
        case 4:
          signedUrl = _context2.sent;
          _context2.next = 7;
          return axios.request({
            method: 'put',
            data: blob,
            url: signedUrl,
            signal: abortController.signal,
            headers: {
              'Content-Type': 'application/octet-stream'
            },
            onUploadProgress: onUploadProgress
          });
        case 7:
          return _context2.abrupt("return", _context2.sent);
        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](1);
          if (!(currentRetry <= MAX_RETRIES)) {
            _context2.next = 19;
            break;
          }
          if (!(retryPolicy === 'exponentialBackoff')) {
            _context2.next = 16;
            break;
          }
          _context2.next = 16;
          return backoff(currentRetry);
        case 16:
          _context2.next = 18;
          return putInS3(blob, signedUrlGenerator, abortController, onUploadProgress, retryPolicy, currentRetry + 1);
        case 18:
          return _context2.abrupt("return", _context2.sent);
        case 19:
          throw _context2.t0;
        case 20:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 10]]);
  }));
  return function putInS3(_x2, _x3, _x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();
export default putInS3;